import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IStudytopicsub } from "../../../Pages/StudyNote.tsx/IStudyNote";

export const ListSubjectNoteSubTopicSubTopicSlice = createSlice({
  name: "ListSubjectNoteSubTopicSlice",
  initialState: {} as IReduxState<IStudytopicsub[]>,

  reducers: {
    listListSubjectNoteSubTopicSlice: (
      state,
      _: PayloadAction<IStudytopicsub>
    ) => {
      state.isLoading = true;
    },
    successListSubjectNoteSubTopicSlice: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureListSubjectNoteSubTopicSlice: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  listListSubjectNoteSubTopicSlice,
  successListSubjectNoteSubTopicSlice,
  failureListSubjectNoteSubTopicSlice,
} = ListSubjectNoteSubTopicSubTopicSlice.actions;

export default ListSubjectNoteSubTopicSubTopicSlice.reducer;
